import React from "react";
import "./LoadingSpinner.css";


export default function LoadingSpinner(prop) {
  return (
    <div className={prop.class == undefined? "text-center customLoader":"text-center customLoader "+prop.class}>
    <div className="loader-centered">
    <img src="assets/img/orange-loader.gif" alt="Loading" className="customChailedLoader"></img>
    </div>
 
    </div>
  );
}